import { all } from 'redux-saga/effects';

import authenticationSagas from './authentication';
import companyGuestSagas from './company';
import feedbackSagas from './feedback';
import layoutSagas from './layout';
import menuCategoriesSagas from './MenuCategories';
import notificationSagas from './notification';
import placeSagas from './place';
import registrationSagas from './registration';
import reservationSagas from './reservation';
import settingSagas from './setting';
import subscriptionSagas from './subscription';
import userSagas from './user';

export default function* rootSaga() {
  yield all([
    ...authenticationSagas,
    ...settingSagas,
    ...layoutSagas,
    ...reservationSagas,
    ...notificationSagas,
    ...feedbackSagas,
    ...registrationSagas,
    ...placeSagas,
    ...userSagas,
    ...menuCategoriesSagas,
    ...subscriptionSagas,
    ...companyGuestSagas,
  ]);
}
